module.exports = __webpack_public_path__ + "292d00f504f856499cb8c3095be2e17a.svg";